import React from "react";

export default () => {
  return (
    <svg
      id="Gruppe_8164"
      data-name="Gruppe 8164"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_7656"
            data-name="Rechteck 7656"
            width="30"
            height="30"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Gruppe_7951" data-name="Gruppe 7951" clip-path="url(#clip-path)">
        <path
          id="Pfad_6724"
          data-name="Pfad 6724"
          d="M20.273,0A11.23,11.23,0,0,0,15,1.275,11.2,11.2,0,0,0,9.727,0C4.363,0,0,3.549,0,7.91c0,3.552,2.94,6.66,7.09,7.613,0,0,.006,1.881,0,2.174l-1.659,0,1.605,1.262c-.066,1.327-.194,2.653-.382,3.965a2.138,2.138,0,0,1-.443.045.88.88,0,0,1-.879-.879V19.453H4.453A4.37,4.37,0,0,0,.011,24.042C.011,27.127,2.537,30,7.09,30H22.91c4.548,0,7.076-2.863,7.076-5.951a4.381,4.381,0,0,0-4.439-4.6h-.879V22.09a.877.877,0,0,1-1.334.751,43.186,43.186,0,0,1-.424-6.024V15.523C27.06,14.57,30,11.462,30,7.91,30,3.549,25.637,0,20.273,0M1.758,7.91A5.493,5.493,0,0,1,4.029,3.627a9.172,9.172,0,0,1,5.7-1.869,9.67,9.67,0,0,1,3.575.666,7.169,7.169,0,0,0-2.7,5.486,6.627,6.627,0,0,0,.45,2.39,3.571,3.571,0,0,1-1.329.247c-1.429,0-2.637-.8-2.637-1.758H5.332A3.328,3.328,0,0,0,7.09,11.608v2.1c-3.144-.861-5.332-3.184-5.332-5.8M20.273,12.3a5.576,5.576,0,0,0,.879-.07s0,5.237.011,5.566a6.181,6.181,0,0,0-1.769-1.269v-4.3a5.576,5.576,0,0,0,.879.07M17.637,16a6.186,6.186,0,0,0-.879-.063l-2.276,0,1.688,1.53a5.234,5.234,0,0,1,1.373,2.177q-.047.721-.119,1.437a4.184,4.184,0,0,1-.355.434,4.072,4.072,0,0,0-1.206,3.094c-1.067-.3-1.489-1.174-2.083-2.588a9.866,9.866,0,0,0-1.328-2.451c-.059-.916-.089-1.842-.089-2.757V15.524A10.657,10.657,0,0,0,15,14.544a10.825,10.825,0,0,0,2.635.979Zm-8.789.816V12.235a5.533,5.533,0,0,0,1.758,0s.008,5.492.021,5.948a6.009,6.009,0,0,0-1.789-.444q.01-.461.01-.922m3.516-3.107V12.466q.245.285.521.553.2.194.416.377a9.234,9.234,0,0,1-.937.314m14.063,8.38v-.756a2.686,2.686,0,0,1,1.8,2.715c0,2.117-1.748,4.193-5.318,4.193H7.09c-3.655,0-5.321-2.177-5.321-4.2a2.68,2.68,0,0,1,1.8-2.709v.756a2.64,2.64,0,0,0,2.637,2.637,3.826,3.826,0,0,0,3.638-4.967c1.287.516,1.757,1.631,2.31,2.947.708,1.683,1.589,3.778,4.661,3.778h1.013l-.143-1c-.248-1.737.167-2.2.692-2.795a3.228,3.228,0,0,0,1.012-2.354,4.273,4.273,0,0,0-.082-.824q.029-.478.048-.956a4.391,4.391,0,0,1,1.792,3.539,2.637,2.637,0,0,0,5.273,0M22.91,13.712v-2.1a3.344,3.344,0,0,0,1.758-2.819H22.91c0,.953-1.207,1.758-2.637,1.758s-2.637-.8-2.637-1.758H15.879a3.343,3.343,0,0,0,1.758,2.819v2.1c-3.11-.859-5.273-3.18-5.273-5.8,0-3.392,3.549-6.152,7.91-6.152a9.172,9.172,0,0,1,5.7,1.869A5.493,5.493,0,0,1,28.242,7.91c0,2.618-2.188,4.941-5.332,5.8"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
